export default __webpack_public_path__ + "static/media/form-vector-1.47328cd0.png";